globalThis.redoStorefront = { type: "bigcommerce", storeUrl: location.host };
globalThis.process = { env: {} };
process.env.IPIFY_API_KEY = "at_S8q5xe1hwi5jKf6CSb4V661KXTKK2";
process.env.REDO_API_CLIENT_VERSION = "";
process.env.REDO_API_URL = "https://shopify-cdn.getredo.com";
process.env.REDO_SHOPIFY_SERVER_URL = "https://shopify-server.getredo.com";
process.env.REDO_SHOPIFY_EXTENSION_URL = "auto";
process.env.AMPLITUDE_API_KEY = "4ea5fb67e1313890e096ab17cce5d093";
